import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  constructor() {
   }
   inMaintenance() {
    return true;
    }
   findSiteNameInFactoryName(factory: string, site: string) {
     if (site === 'Yangon') {
       return false;
     }
     if (factory === 'Gateway Manufacturing PHP' && site === 'Cavite - Savoury') {
       return true;
     } else if (factory.toLowerCase().includes(site.toLowerCase())) {
      return true;
     } else if (site.indexOf('-') > 0) {
      const siteArray = site.split('-');
      siteArray.forEach(s => {
        if (factory.toLowerCase().includes(s.toLowerCase())) {
          return true;
        }
      });
    } else if (site.indexOf(' ') > 0) {
      const siteArray = site.split(' ');
      siteArray.forEach(s => {
        if (factory.toLowerCase().includes(s.toLowerCase())) {
          return true;
        }
      });
    }
  }

}
